export const AUTH_COOKIE_NAME = 'mn-token';
export const OT_DATA_SUBJECT_PARAMS_COOKIE_NAME = 'mn-ot-data-subject-params';

// Better Auth cookie naming. Single source of truth shared between the Better Auth config
// (`cookiePrefix` in lib/auth.ts) and the server-side session cookie-name resolution, so the base
// cookie name can never drift.
export const BETTER_AUTH_COOKIE_PREFIX = 'milanote';
export const BETTER_AUTH_SESSION_COOKIE_BASE_NAME = 'session_token';

// This is used to track any consent settings changes external to app.milanote.com (such as from milanote.com)
export const OT_LAST_ACTIVE_GROUPS_LOCAL_STORAGE = 'milanote.oneTrustActiveGroups';
